/** Helpers for rendering PIM / inventory-item catalog detail fields. */

export function normalizeTechnicalSections(raw) {
  const list = Array.isArray(raw?.data)
    ? raw.data.map((section) => (section?.attributes ? { ...section.attributes, id: section.id } : section))
    : Array.isArray(raw)
      ? raw
      : [];
  return list
    .map((section) => {
      if (!section || typeof section !== "object") return null;
      const images = Array.isArray(section.images?.data)
        ? section.images.data
        : Array.isArray(section.images)
          ? section.images
          : [];
      return {
        title: String(section.title || "").trim(),
        body: String(section.body || "").trim(),
        images,
      };
    })
    .filter((section) => section && (section.title || section.body || section.images.length));
}

export function normalizeSpecEntries(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return [];
  return Object.entries(raw)
    .map(([key, value]) => [String(key || "").trim(), value == null ? "" : String(value).trim()])
    .filter(([key, value]) => key && value);
}

export function normalizeTransmissionNames(raw) {
  const rows = raw?.data || raw || [];
  return (Array.isArray(rows) ? rows : [])
    .map((row) => row?.attributes?.name || row?.name || row?.label || "")
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}

/** Prefer marketing copy when present; otherwise short PIM description. */
export function productStoryText(product) {
  const marketing = String(product?.marketingDescription || "").trim();
  if (marketing && marketing.toLowerCase() !== "null") return marketing;
  const description = String(product?.description || "").trim();
  if (description && description.toLowerCase() !== "null") return description;
  return "";
}

export function hasHtml(value) {
  return String(value || "").includes("<");
}
